import { Trans, useTranslation } from "react-i18next";
import { LINE_BREAKS } from "~/components/ui/max-width-line-break";

const STATS = ["fuel", "accidents", "on_time", "maintenance"] as const;

// Title tile beside a 2x2 grid of percentage stats; stacks below lg.
// Must render inside the .fleet token scope.
export function FleetRoi() {
    const { t } = useTranslation("fleet");

    return (
        <section aria-labelledby="fleet-roi-title" className="py-8 lg:py-[60px]">
            <div className="wrap grid gap-6 lg:grid-cols-2 lg:gap-x-8">
                <div className="bg-bg-alt flex min-h-[196px] flex-col justify-center gap-8 rounded-lg px-4 py-6 lg:px-8 lg:py-[57px] xl:px-12">
                    <h2
                        id="fleet-roi-title"
                        className="font-display text-text-heading max-w-[277px] text-xl leading-[1.15] font-extrabold md:max-w-[533px] lg:text-[36px] lg:leading-[1.1] xl:text-4xl"
                    >
                        {t("roi.title")}
                    </h2>
                    <p className="text-text-body-secondary lg:text-md max-w-[277px] text-sm leading-5 md:max-w-[484px] lg:leading-[1.1]">
                        {t("roi.body")}
                    </p>
                </div>

                <ul className="grid grid-cols-2 content-start gap-4">
                    {STATS.map((id) => (
                        <li
                            key={id}
                            className="bg-bg-alt flex h-[149px] flex-col items-center justify-center rounded-lg px-1 py-4 text-center lg:px-6"
                        >
                            <p className="text-text-heading flex items-start">
                                <span className="font-display text-xl leading-[1.15] font-extrabold lg:text-4xl lg:leading-[1.1]">
                                    {t(`roi.stats.${id}.value`)}
                                </span>
                                <span className="text-sm leading-5 font-bold tracking-[0.14px] lg:text-xl lg:leading-8 lg:tracking-normal">%</span>
                            </p>
                            <p className="text-text-body-tertiary text-sm leading-5 lg:text-base lg:leading-[1.5]">
                                <Trans t={t} i18nKey={`roi.stats.${id}.description`} components={LINE_BREAKS} />
                            </p>
                        </li>
                    ))}
                </ul>

                {/* Under the stats column only, so the title tile matches the grid's height. */}
                <p className="text-text-body-secondary -mt-2 text-center text-xs leading-[18px] lg:col-start-2 lg:text-right">
                    {t("roi.source")}
                </p>
            </div>
        </section>
    );
}

export default FleetRoi;
